import * as React from 'react'
import {
  WrappedFieldProps,
  Field,
  GenericField,
  BaseFieldProps
} from 'redux-form'
import Select from 'react-select'
import ControlWrapper from './ControlWrapper'

export interface SelectOption {
  value: any
  label: string
}

export interface SelectControlCustomProps {
  options: SelectOption[]
  multi?: boolean
}

export type SelectControlProps = WrappedFieldProps & SelectControlCustomProps

export const styles = error => ({
  control: (base, state) => ({
    ...base,
    borderColor: error ? 'red' : base.borderColor
  })
})

const SelectControl: React.SFC<SelectControlProps> = props => {
  const { input, label, meta, multi, options } = props

  return (
    <ControlWrapper name={input.name} label={label} meta={meta}>
      <Select
        onBlur={() => (input.onBlur as any)()}
        onFocus={() => (input.onFocus as any)()}
        value={input.value}
        onChange={input.onChange}
        isMulti={multi}
        name={input.name}
        options={options}
        styles={styles(meta.touched && meta.error)}
        isClearable={true}
      />
    </ControlWrapper>
  )
}

const CustomField = Field as new () => GenericField<SelectControlCustomProps>

export type SelectControlFieldProps = BaseFieldProps<SelectControlCustomProps> &
  SelectControlCustomProps

export const SelectControlField: React.SFC<SelectControlFieldProps> = props => (
  <CustomField {...props} component={SelectControl} />
)

export default SelectControl



// WEBPACK FOOTER //
// ./src/components/form/SelectControl.tsx